// Configuración global de dayjs para TODA la app: locale español.
//
// Importar este módulo (side-effect) fija el locale 'es' una sola vez. Lo
// importan los tres entry points para que `formatDate`/`formatDateTime`
// (lib/format.ts) y cualquier `dayjs().format('MMM')` rindan meses en español
// en cada entorno:
//   - runtime de la app   → src/main.tsx
//   - tests (Vitest)      → src/tests/setup.ts
//   - lab visual (Ladle)  → .ladle/components.tsx
//
// Sin esto, los entornos que no ejecutan main.tsx (tests, Ladle) usarían el
// locale por defecto de dayjs (inglés) y validarían/renderizarían meses en el
// idioma equivocado.
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

export { dayjs };
